import { ModalHelper } from "../../Helpers/ModalHelper";
import { Select2Helper } from "../../Helpers/Select2Helper";
import { StringHelper } from "../../Helpers/StringHelper";

export class UpdateImportDataHeaderManager {


//#region Reorder popup

private reorderPopupHtml : string = `<div class="modal-dialog modal-xl">
	<div class="modal-content">
		<div class="modal-header py-2">
			<h5 class="modal-title">Update line numbers</h5>

			<button type="button" class="btn-close" aria-label="Close" data-bs-dismiss="modal"></button>
		</div>
		<div class="modal-body pt-0">
			<div class="row mt-2">
				<div class="col-4 mb-2">
					<div class="form-check">
						<input class="form-check-input" type="radio" id="create-valid-numbers" name="update-line-numbers-option" value="create-valid-numbers" checked>
						<label class="form-check-label" for="create-valid-numbers">
							Create valid numbers from selected lines
						</label>
					</div>
				</div>
                <div class="col-8 mb-2">
					<fieldset class="border">
						<legend class="w-auto">Update line numbers from selected lines to be valid for your ERP</legend>
						<div class="fieldset-content">
							<div class="row mb-2">
								<div class="col-3">
									<label>Example 1:</label>
								</div>
								<div class="col-9">
									<div>
										<label>Extracted line numbers are A, B, C</label></br>
										<label style="font-weight: 600 !important">New line numbers will be 1, 2, 3</label>
									</div>
								</div>
							</div>
							
							<div class="row">
								<div class="col-3">
									<label>Example 2:</label>
								</div>
								<div class="col-9">
									<div>
										<label>Extracted line numbers are 1.0, 2.0, 3.0</label>
										<label style="font-weight: 600 !important">New line numbers will be 1, 2, 3</label>
									</div>
								</div>
							</div>
						</div>
					</fieldset>
				</div>
				<div class="col-4 mb-4">
					<div class="form-check">
						<input class="form-check-input" type="radio" id="update-numbers-from-selected" name="update-line-numbers-option" value="update-numbers-from-selected">
						<label class="form-check-label" for="update-numbers-from-selected">
							Update numbers from selected lines
						</label>
					</div>
                    <div class="d-flex">
                        <label>Start:</label>
                        <input id="start-input" class="form-control form-control-xs ms-2 my-auto" style="width:75px;" disabled type="number" min="1" value="1" />
                    </div>
				</div>
				<div class="col-8 mb-2">
					<fieldset class="border">
						<legend class="w-auto">Update numbers from selected lines based on the start number</legend>
						<div class="fieldset-content">
							<div class="row mb-2">
								<div class="col-3">
									<label>Example:</label>
								</div>
								<div class="col-9">
									<div>
										<label>You selected 3 lines with number 5, 6, 7</label>
										<label>You want to start with line number 2</label>
										<label style="font-weight: 600 !important">Line numbers will be update to 2, 3, 4</label>
									</div>
								</div>
							</div>
						</div>
					</fieldset>
				</div>
                <div class="col-12 mb-2">
					<div class="form-check">
						<input class="form-check-input" type="radio" id="revert-numbers-back-to-original" name="update-line-numbers-option" value="revert-numbers-back-to-original">
						<label class="form-check-label" for="revert-numbers-back-to-original">
							Revert back to original line numbers
						</label>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer py-2">
			<div class="btn-group btn-group-sm">
				<button type="button" class="btn btn-primary" data-bs-dismiss="modal">Close</button>
				<button type="button" class="ms-2 btn btn-sm btn-secondary" data-bs-dismiss="modal" id="update-line-numbers-button">Update</button>
			</div>
		</div>
	</div>
</div>`;

//#endregion

    constructor(private containerElement: JQuery) { }

    private linesTable : JQuery<HTMLElement>;
    private linesTableBody : JQuery<HTMLElement>;
    private addLineButton : JQuery<HTMLElement>;

    private templateElement : JQuery<HTMLElement>;

    private selectAllCheckboxChecked : boolean;
    private selectAllCheckbox : JQuery<HTMLElement>;


    public initialize() {
        this.selectAllCheckboxChecked = false;

        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;

        this.linesTable = this.containerElement.find('#lines-table');
        this.linesTableBody = this.linesTable.find('tbody');
        this.addLineButton = this.containerElement.find('#add-line-button');

        this.selectAllCheckbox = this.containerElement.find('#select-all-checkbox');

        this.templateElement = this.containerElement.find('#import-doc-detail-row');

        StringHelper.bindNumberStringInputs();

        self.containerElement.find('select.select2').each((index, element) => {
            var selectElement = $(element);
            Select2Helper.BindSelect2Input(selectElement);
        });
    }

    private bindEvents() {
        var self = this;

        self.addLineButton.off('click').on('click', () => {
            var newListItem = $(self.templateElement.html());

            this.bindLineTableRow(newListItem);
    
            self.linesTableBody.append(newListItem);

            StringHelper.bindNumberStringInputs();

            var maxLineNoInput = self.getMaxLineItemNo(self.linesTableBody.find('tr').find('input[data-line-no-input]'));

            newListItem.find('input[data-line-no-input]').val(maxLineNoInput + 1);

            self.bindSortableOfTable();
        });

        self.selectAllCheckbox.off('change').on('change', () => {
            var isChecked = self.selectAllCheckbox.is(':checked');
            self.selectAllCheckboxChecked = isChecked;

            self.linesTableBody.find('input[type="checkbox"]').prop( "checked", isChecked);
        })

        self.linesTableBody.find('tr').each((index, element) => {
            var listItemRow = $(element);
            self.bindLineTableRow(listItemRow);
        }) 

        var form =  this.containerElement.find('form');
        var submitButton = form.find(':submit');

        submitButton.off('click').on('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            submitButton.prop('disabled', true);

            var isValid = true;

            self.linesTableBody.find('tr').each((rowIndex, rowElement) => {
                var row = $(rowElement);
                row.find('[data-set-name]').each((index, nameInput) => {
                    var parsedNameInput = $(nameInput);
                    var nameToSet : string = parsedNameInput.data('set-name').toString();
                    parsedNameInput.prop('name', nameToSet.replace('<I>', `${rowIndex}`))

                    if(!row.hasClass('d-none') && parsedNameInput.is('input:text')) {
                        var value = parsedNameInput.val();
                        if(value == undefined || value == '') {
                            if(parsedNameInput.prop('required')) {
                                isValid = false;
                                parsedNameInput.addClass('is-invalid');         
                            }
                            
                        }
                    }
                })
            })

            if(isValid) {
                form.trigger('submit');
            }
            else {
                submitButton.prop('disabled', false);
            }
        });

        var reorderLineNumbersModal = new ModalHelper;
        reorderLineNumbersModal.createModal("reorder-line-numbers-popup", true);

        var reorderLineNumbersButton = self.containerElement.find('#reorder-line-numbers-button');
        reorderLineNumbersButton.off('click').on('click', () => { 
            reorderLineNumbersModal.loadFromHtml(this.reorderPopupHtml, undefined, () => {
                var reorderLineNumbersModalContainer = reorderLineNumbersModal.getModalContainer();
                var startInput = reorderLineNumbersModalContainer.find('#start-input');

                startInput.off('input').on('input', () => {
                    var startInputValue = startInput.val();
                    if(startInputValue == undefined || startInputValue.toString().lenth == 0 || +startInputValue < 1) {
                        startInput.val(1);
                    }
                })

                reorderLineNumbersModalContainer.find("input[name='update-line-numbers-option']").off('change').on('change', function() {
                    var selectedOption = $(this).val();

                    switch(selectedOption) {
                        default:
                            startInput.prop('disabled', true);
                        break;
                        case 'update-numbers-from-selected':
                            startInput.prop('disabled', false);
                        break;
                    }
                })

                var updateButton = reorderLineNumbersModalContainer.find('#update-line-numbers-button');

                updateButton.off('click').on('click', () => {
                    var selectedOption = reorderLineNumbersModalContainer.find('input[name="update-line-numbers-option"]:checked').val();

                    switch(selectedOption) {
                        case 'create-valid-numbers':
                            self.createValidLineNumbers();
                        break;

                        case 'update-numbers-from-selected':
                            self.updateLineNumbersFromStartNumber(+startInput.val());
                        break;                        
                        
                        case 'revert-numbers-back-to-original':
                            self.resetTable();
                            //self.updateLineNumbersFromStartNumber(+startInput.val());
                        break;
                    }
                })

            }, undefined, 10000);
        });

        self.bindSortableOfTable();

        var newListItemFix = $(self.templateElement.html());
        self.linesTableBody.append(newListItemFix);
        newListItemFix.remove();
    }

    private createValidLineNumbers() {
        var self = this;

        var selectedTableRows = self.linesTableBody.find('input[type="checkbox"]:checked').closest('tr');

        selectedTableRows.find('input[data-line-no-input]').each((index, element) => {
            var lineItemNoInput = $(element);
            var lineItemNo = lineItemNoInput.val();

            if(lineItemNo != undefined)  {
                var newItemNo = lineItemNo; 

                if(lineItemNo.toString().length == 0) {
                    newItemNo = self.getMaxLineItemNo(lineItemNoInput.closest('tr').prevAll().find('input[data-line-no-input]')); 
                    newItemNo += 1;
                }
                else if($.isNumeric(lineItemNo)) {
                    newItemNo = Math.floor(+lineItemNo)
                }
                else if(!(lineItemNo.toString()+"").match(/^\d+$/)) {
                    newItemNo = StringHelper.convertLetterToNumber(lineItemNo.toString())
                    
                }

                lineItemNoInput.val(newItemNo);
            }
        })
    }    
    
    private updateLineNumbersFromStartNumber(startNumber:number) {
        var self = this;

        var currentNumber = startNumber;
        var selectedTableRows = self.linesTableBody.find('input[type="checkbox"]:checked').closest('tr');

        selectedTableRows.find('input[data-line-no-input]').each((index, element) => {
            $(element).val(currentNumber);
            currentNumber++;
        });
    }

    private bindLineTableRow(row : JQuery<Element>) {
        var self = this;

        var checkbox = row.find('input[type="checkbox"]');
        checkbox.prop('checked', self.selectAllCheckboxChecked);

        checkbox.off('change').on('change', () => {
            self.checkboxChanged();
        })

        // var englishValueInput = row.find('#english-value-input');
        // var spanishValueInput = row.find('#spanish-value-input');
        // var hiddenDeletedInout = row.find('#hidden-deleted-input');

        // englishValueInput.on('keyup', () => {
        //     var value = englishValueInput.val();
        //     if(value == undefined || value == '') {
        //         englishValueInput.addClass('is-invalid');
        //     }
        //     else {
        //         englishValueInput.removeClass('is-invalid');
        //     }
        // });

        // spanishValueInput.on('keyup', () => {
        //     var value = spanishValueInput.val();
        //     if(value == undefined || value == '') {
        //         spanishValueInput.addClass('is-invalid');
        //     }
        //     else {
        //         spanishValueInput.removeClass('is-invalid');
        //     }
        // });

        var removeButton = row.find('#remove-button');
        removeButton.off('click').on('click', () => {
            row.remove();

            // englishValueInput.prop('required', false);
            // spanishValueInput.prop('required', false);

            // hiddenDeletedInout.val('true');
        });

    }

    private checkboxChanged() {
        var self = this;

        var allChecked = self.linesTableBody.find('input[type="checkbox"]:checked').length == self.linesTableBody.find('input[type="checkbox"]').length;
        
        self.selectAllCheckbox.prop('checked', allChecked);
        self.selectAllCheckboxChecked = allChecked;
    }

    private getMaxLineItemNo(inputsToCheckIn) {
        var self = this;

        var maxLineItemNo = 0;

        inputsToCheckIn.each((index, element) => {
            var lineItemNoInput = $(element);
            var lineItemNo = lineItemNoInput.val();

            if(lineItemNo != undefined && (lineItemNo.toString()+"").match(/^\d+$/) )  {
                if(+lineItemNo > maxLineItemNo) {
                    maxLineItemNo = +lineItemNo;
                }
            }
        })

        return maxLineItemNo;
    }

    private bindSortableOfTable() {
        var self = this;
        (self.linesTableBody as any).sortable({
            items: "> tr",
            appendTo: "parent",
            axis: "y",
            handle: ".draggable-cell",
            forcePlaceholderSize: true,
            forceHelperSize : true,
            //placeholder: "shrink",
            // helper: function(e, ui) {
            //     ui.children().each(function() {  
            //         $(this).width($(this).width());  
            //     });  
            //     return ui; 
            // },
            start: (_, ui) => {
                ui.item.css('border-left', '2px solid #377DFF')
            },
            stop: (_, ui) => {
                ui.item.css('border-left', '')
            },
            update: (_, ui) => {

            }
        }).disableSelection();

        //(self.listItemsTableBody as any).sortable("disable");
    }


        // var createValidLineNumbersButton = self.containerElement.find('#create-valid-line-numbers-button');
        // createValidLineNumbersButton.off('click').on('click', () => {

        //     self.linesTableBody.find('tr').find('input[data-line-no-input]').each((index, element) => {
        //         var lineItemNoInput = $(element);
        //         var lineItemNo = lineItemNoInput.val();

        //         if(lineItemNo != undefined)  {
        //             var newItemNo = lineItemNo; 

        //             if(lineItemNo.toString().length == 0) {
        //                 newItemNo = self.getMaxLineItemNo(lineItemNoInput.closest('tr').prevAll().find('input[data-line-no-input]')); 
        //                 newItemNo += 1;
        //             }
        //             else if($.isNumeric(lineItemNo)) {
        //                 newItemNo = Math.floor(+lineItemNo)
        //             }
        //             else if(!(lineItemNo.toString()+"").match(/^\d+$/)) {
        //                 newItemNo = StringHelper.convertLetterToNumber(lineItemNo.toString())
                        
        //             }

        //             lineItemNoInput.val(newItemNo);
        //         }
        //     })
        // })
        
        // var recreateAllLineNumbersButton = self.containerElement.find('#recreate-all-line-numbers-button');
        // recreateAllLineNumbersButton.off('click').on('click', () => {
        //     var lineNumber = 1;
        //     self.linesTableBody.find('tr').find('input[data-line-no-input]').each((index, element) => {
        //         var lineItemNoInput = $(element);
        //         lineItemNoInput.val(lineNumber);
        //         lineNumber++;
        //     })
        // })


    private resetTable() {
        var self = this;

        (self.linesTableBody.find('tr') as any).sort(function(a, b) {
            const aInput = $(a).find("input[data-original-seq-no]");
            const bInput = $(b).find("input[data-original-seq-no]");

            const aVal = (aInput.length && aInput.val()) ? parseInt(aInput.val() as string, 10) : Number.MAX_SAFE_INTEGER;
            const bVal = (bInput.length && bInput.val()) ? parseInt(bInput.val() as string, 10) : Number.MAX_SAFE_INTEGER;

            return aVal - bVal;
        }).appendTo(self.linesTable);

        self.linesTableBody.find('tr').each((index, element) => {
            var tableRow = $(element);

            var originalLineItemNoVal = tableRow.find('input[data-original-line-item-no]').val();
            if(originalLineItemNoVal != undefined) {
               tableRow.find('input[data-line-no-input]').val(originalLineItemNoVal);
            }
        })
    }
}